import { EyeOff } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgViewHide = mkIcon(EyeOff);